module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"emptyBasket":"Twój koszyk jest pusty","goToOffer":"Przejdź do oferty!"},"en":{"emptyBasket":"Your cart is empty","goToOffer":"Go to the offer!"}}')
  delete Component.options._Ctor
}
